import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { Link } from "react-router-dom";

export default function AdminDrops() {
  const [drops, setDrops] = useState([]);
  useEffect(() => { api.get("/drops").then((r) => setDrops(r.data.drops)); }, []);

  return (
    <div className="p-8" data-testid="admin-drops-page">
      <div className="mb-6">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">SCHEDULING</div>
        <h1 className="font-display text-5xl tracking-tighter mt-2">DROPS ({drops.length})</h1>
        <p className="text-black/50 text-sm mt-2 font-mono">Manage drop schedule via Products → Mark as Drop + set release date.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {drops.map((d) => (
          <div key={d.id} className="border border-black/10 bg-white overflow-hidden">
            <img src={d.images?.[0]} alt="" className="w-full aspect-[3/4] object-cover" />
            <div className="p-4">
              <div className="font-display tracking-tight uppercase">{d.name}</div>
              <div className="text-xs font-mono text-black/40 mt-1">RELEASE: {d.drop_release_at ? new Date(d.drop_release_at).toLocaleString() : "—"}</div>
              <div className="flex justify-between items-center mt-3">
                <span className="font-display">{formatINR(d.price)}</span>
                <Link to={`/p/${d.id}`} className="font-display tracking-widest text-[10px] border border-black/30 px-3 py-1 hover-invert">VIEW</Link>
              </div>
            </div>
          </div>
        ))}
        {!drops.length && <div className="col-span-full text-black/40 p-12 text-center font-mono text-xs border border-black/10">NO DROPS SCHEDULED</div>}
      </div>
    </div>
  );
}
